import { compose } from 'redux';
import { connect } from 'react-redux';
import React, { useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';

import { first } from 'lodash';
import { func, shape, string } from 'prop-types';
import { useFeatureFlags } from '@playbookux/playbook-web-core';
import withLayout from '../../../core/components/with-layout';

import {
  Container,
  ContentContainer,
  Menu,
  VerticalMenuContainer,
} from './styles';

import General from './general';
import Billing from './billing';
import Team from './team';
import Usage from './usage';
import Storage from './storage';
import { GET_CURRENT_COMPANY_MEMBER } from './graphql';

export const Tabs = {
  GENERAL: 'general',
  TEAM: 'team',
  BILLING: 'billing',
  USAGE: 'usage',
  STORAGE: 'storage',
};

const Account = (props) => {
  const {
    history = {},
    userId = '',
    companyId = '',
  } = props;

  const [activeItem, setActiveItem] = useState(Tabs.GENERAL);

  const { data: currentData = {} } = useQuery(GET_CURRENT_COMPANY_MEMBER, {
    variables: {
      userId,
      companyId,
    },
    skip: !userId || !companyId,
  });

  const {
    featureFlags: { uploadResearch } = {},
  } = useFeatureFlags(companyId);

  const currentUser = useMemo(() => first(currentData?.companyMembers), [currentData]);

  const isAdmin = useMemo(() => currentUser && currentUser.role === 'admin', [currentUser]);

  return (
    <Container>
      <VerticalMenuContainer>
        <Menu vertical>
          <Menu.Item
            data-tab="general"
            active={activeItem === Tabs.GENERAL}
            onClick={() => setActiveItem(Tabs.GENERAL)}
          >
            General
          </Menu.Item>
          <Menu.Item
            data-tab="billing"
            active={activeItem === Tabs.BILLING}
            onClick={() => setActiveItem(Tabs.BILLING)}
          >
            Billing
          </Menu.Item>
          {isAdmin && (
            <Menu.Item
              data-tab="usage"
              active={activeItem === Tabs.USAGE}
              onClick={() => setActiveItem(Tabs.USAGE)}
            >
              Usage
            </Menu.Item>
          )}
          {isAdmin && (
            <Menu.Item
              data-tab="team"
              active={activeItem === Tabs.TEAM}
              onClick={() => setActiveItem(Tabs.TEAM)}
            >
              Team
            </Menu.Item>
          )}
          {isAdmin && uploadResearch && (
            <Menu.Item
              data-tab="storage"
              active={activeItem === Tabs.STORAGE}
              onClick={() => setActiveItem(Tabs.STORAGE)}
            >
              Storage
            </Menu.Item>
          )}
        </Menu>
      </VerticalMenuContainer>
      <ContentContainer activeItem={activeItem}>
        {activeItem === Tabs.GENERAL && <General history={history} />}
        {activeItem === Tabs.TEAM && <Team history={history} />}
        {activeItem === Tabs.BILLING && <Billing history={history} />}
        {activeItem === Tabs.USAGE && <Usage history={history} />}
        {activeItem === Tabs.STORAGE && uploadResearch && <Storage history={history} />}
      </ContentContainer>
    </Container>
  );
};

Account.propTypes = {
  history: shape({
    push: func,
  }).isRequired,
  userId: string.isRequired,
  companyId: string.isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  userId: authentication.profile.user_id,
});

const enhance = compose(
  withLayout({ selectedTab: null }),
  connect(mapStateToProps, null),
);

export default enhance(Account);
